import { useContext, useEffect, useState } from "react";
import FullScreenCard from "../shared/FullScreenCard";
import { fetchGet } from '../../utils/fetch';
import { transformDate } from '../../utils/date';
import TableRequest from "../TableRequest";
import GeneralContext from "../../context/GeneralContext";

function ProcessedRequests() {

    const { changeUserMenu } = useContext(GeneralContext);

    const [historyList, setHistoryList] = useState([]);

    const prepareList = (list) => {
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].status !== 'pending') {
                list[i].request_date = transformDate(list[i].request_date);
                list[i].status_change_date = transformDate(list[i].status_change_date);
                newList.push(list[i]);
            }
        }
        return newList;
    }

    useEffect(() => {
        const getRequestsFunction = async () => {
            const response = await fetchGet('requests/list-my-requests');
            if (response.success) {
                const processedList = prepareList(response.list);
                setHistoryList(processedList);
            }
        }
        getRequestsFunction();
    }, []);

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeUserMenu} backNavigationTarget={'history'}>
        <h1>Solcitudes procesadas</h1>
        {historyList.map((item) => (
            <div key={item.id}>
            <br />
            <TableRequest data={item} />
            <hr />
            </div>
        ))}
        <br />
    </FullScreenCard>
  )
}

export default ProcessedRequests